module.exports = __webpack_public_path__ + "img/thumb1.2ea78089.png";